import React, { Fragment } from 'react';
import { RadioGroup } from '@headlessui/react';

import { SortMethods } from '../../../../../modules/sortAndFilter/config/SortAndFilterConfig';
import RadioIcon from '../../../../_ui/_blocks/Form/Inputs/Radio/RadioIcon/RadioIcon';

export const sortMethodLabels = {
    alphabeticalAZ: 'Alphabetical (A - Z)',
    alphabeticalZA: 'Alphabetical (Z - A)',
    newest: 'Newest',
    popularity: 'Most popular',
    priceLowToHigh: 'Price (Low - High)',
    priceHighToLow: 'Price (High - Low)',
    review: 'Highest rated',
    relevance: 'Relevance',
};

interface Props {
    sortMethod: SortMethods;
}

const SortingOption = ({ sortMethod }: Props) => (
    <RadioGroup.Option value={sortMethod} as="li" className="flex items-center justify-between cursor-pointer">
        {({ checked }) => (
            <Fragment>
                <RadioGroup.Label className="cursor-pointer text-090">{sortMethodLabels[sortMethod]}</RadioGroup.Label>
                <RadioIcon checked={checked} />
            </Fragment>
        )}
    </RadioGroup.Option>
);

export default SortingOption;
